"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const LoadingService_1 = require("../Services/LoadingService");
const react_router_dom_1 = require("react-router-dom");
const FormSelect_1 = __importDefault(require("../components/FormSelect"));
const FormText_1 = __importDefault(require("../components/FormText"));
const formik_1 = require("formik");
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const axios_1 = __importDefault(require("axios"));
const Yup = __importStar(require("yup"));
const react_bootstrap_1 = require("react-bootstrap");
const FormSwitch_1 = __importDefault(require("../components/FormSwitch"));
const FormTextArea_1 = __importDefault(require("../components/FormTextArea"));
const ToastService_1 = require("../Services/ToastService");
const utilities_1 = require("../assets/utilities/utilities");
const ApiService_1 = require("../Services/ApiService");
const ReportPage = () => {
    var _a, _b;
    const { id } = (0, react_router_dom_1.useParams)();
    const { showToast } = (0, react_1.useContext)(ToastService_1.ToastContext);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { stopLoading, startLoading } = (0, react_1.useContext)(LoadingService_1.LoadingContext);
    const [libMotivoSegnalazione, setLibMotivoSegnalazione] = react_1.default.useState([]);
    const [libNonConformita, setLibNonConformita] = react_1.default.useState([]);
    const [product, setProduct] = react_1.default.useState();
    (0, react_1.useEffect)(() => {
        if (!id) {
            showToast('danger', 'Segnalazione', 'Errore nella richiesta della divisa');
            navigate('/la-mia-dotazione');
            return;
        }
        const fetchData = async () => {
            startLoading();
            try {
                const [libMotivoSegnalazioneFetch, libNonConformitaFetch, fetchProduct] = await Promise.all([
                    fetchLibMotivoSegnalazione(),
                    fetchLibNonConformita(),
                    (0, ApiService_1.fetchGetProductById)(id),
                ]);
                setLibMotivoSegnalazione(libMotivoSegnalazioneFetch.data);
                setLibNonConformita(libNonConformitaFetch.data);
                setProduct(fetchProduct);
                stopLoading();
            }
            catch (error) {
                stopLoading();
                showToast('danger', 'Segnalazione', 'Errore nella richiesta delle librerie: ' + error);
                console.error("Errore nel fetch:", error);
            }
        };
        fetchData();
    }, []);
    const initialValues = {
        description: null,
        not_conformity: { value: "", label: "" },
        pieces: 0,
        used_item: false,
        washed_item: false,
        note: "",
    };
    const formik = (0, formik_1.useFormik)({
        initialValues: initialValues,
        validationSchema: Yup.object({
            description: Yup.mixed().required("Devi selezionare una opzione"),
            not_conformity: Yup.mixed().when('description', ([field]) => { if ((field === null || field === void 0 ? void 0 : field.value) == "2") {
                return Yup.mixed().required();
            }
            else {
                return Yup.mixed().nullable();
            } }),
            pieces: Yup.number().when('description', ([field]) => { if ((field === null || field === void 0 ? void 0 : field.value) == "2") {
                return Yup.number().required();
            }
            else {
                return Yup.number().nullable();
            } }),
            used_item: Yup.boolean().nullable(),
            washed_item: Yup.boolean().nullable(),
            note: Yup.string().nullable()
        }),
        onSubmit: (values) => {
            console.log('values', values);
            const data = {
                report: values,
                product: product,
            };
            if (data.report && data.product) {
                sendReport(data);
            }
        },
    });
    const fetchLibMotivoSegnalazione = async () => {
        try {
            const response = await axios_1.default.get('/api/divise/get-lib-motivo-segnalazione');
            return response.data;
        }
        catch (error) {
            console.error('Error:', error);
        }
    };
    const fetchLibNonConformita = async () => {
        try {
            const response = await axios_1.default.get('/api/divise/get-lib-non-conformita');
            return response.data;
        }
        catch (error) {
            console.error('Error:', error);
        }
    };
    // send the report to the server
    const sendReport = async (data) => {
        try {
            startLoading();
            const response = await axios_1.default.post('/api/divise/send-report', data);
            const result = response.data;
            showToast('success', 'Segnalazione', 'Segnalazione inviata con successo');
            window.scrollTo(0, 0);
            navigate('/la-mia-dotazione');
        }
        catch (error) {
            stopLoading();
            console.error('Error:', error);
            showToast('danger', 'Segnalazione', 'Errore durante la segnalazione');
        }
    };
    function goToMyEquipment() {
        window.scrollTo(0, 0);
        navigate('/la-mia-dotazione');
    }
    return (react_1.default.createElement("div", { className: "container p-0" },
        react_1.default.createElement("h1", { className: "title my-0" }, "Segnalazione"),
        react_1.default.createElement("p", { className: "mt-2" }, "Segnala la non conformit\u00E0 della tua divisa"),
        react_1.default.createElement("hr", null),
        product && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h3", { className: "text-capitalize fw-bold h6 mt-3 mb-3" }, product.name),
            react_1.default.createElement("div", { className: "box-shadow-9 br-20 p-3" },
                react_1.default.createElement("div", { className: "d-flex align-items-center w-100" },
                    react_1.default.createElement("div", { className: "d-flex gap-2 align-items-center" },
                        react_1.default.createElement("div", null, product && react_1.default.createElement("img", { className: "overflow-hidden br-10", width: 50, src: (0, utilities_1.returnImageCorrect)(product.category), alt: product.name })),
                        react_1.default.createElement("div", { className: "h6 fw-bold" }, product === null || product === void 0 ? void 0 : product.name))),
                react_1.default.createElement("hr", null),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "label fw-bold text-black" }, "Taglia"),
                    react_1.default.createElement("p", { className: "mb-0" }, product === null || product === void 0 ? void 0 : product.size)))),
        react_1.default.createElement(formik_1.Formik, { initialValues: formik.initialValues, onSubmit: formik.handleSubmit },
            react_1.default.createElement(Form_1.default, { onSubmit: formik.handleSubmit },
                react_1.default.createElement("div", { className: "mt-4 mb-4 relative z-index-100" }, libMotivoSegnalazione && react_1.default.createElement(FormSelect_1.default, { name: "description", value: formik.values.description, formik: formik, label: "Descrizione", options: libMotivoSegnalazione })),
                ((_b = (_a = formik.values) === null || _a === void 0 ? void 0 : _a.description) === null || _b === void 0 ? void 0 : _b.value) == "2" && react_1.default.createElement("div", { className: "mt-4 mb-4" },
                    react_1.default.createElement("div", { className: "mb-4" }, libNonConformita && react_1.default.createElement(FormSelect_1.default, { name: "not_conformity", value: formik.values.not_conformity, formik: formik, label: "Non conformit\u00E0", options: libNonConformita })),
                    react_1.default.createElement("div", { className: "mb-4" },
                        react_1.default.createElement(FormText_1.default, { name: "pieces", value: formik.values.pieces, onChange: formik.handleChange, type: "number", label: "Numero di pezzi", placeholder: "Inserisci qui" }))),
                react_1.default.createElement("div", { className: "mb-4" },
                    react_1.default.createElement(FormSwitch_1.default, { name: "used_item", value: formik.values.used_item, onChange: formik.handleChange, id: "used_item", label: "Capo indossato" })),
                react_1.default.createElement("div", { className: "mb-4" },
                    react_1.default.createElement(FormSwitch_1.default, { name: "washed_item", value: formik.values.washed_item, onChange: formik.handleChange, id: "washed_item", label: "Capo lavato" })),
                react_1.default.createElement("div", { className: "mb-5" },
                    react_1.default.createElement(FormTextArea_1.default, { name: "note", value: formik.values.note, onChange: formik.handleChange, label: "Note aggiuntive" })),
                react_1.default.createElement("div", { className: "d-flex gap-3" },
                    react_1.default.createElement(react_bootstrap_1.Button, { onClick: goToMyEquipment, className: "br-10 w-100", variant: "secondary" }, "Annulla"),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", type: "submit", className: "br-10 w-100", disabled: !formik.isValid }, "Prossimo"))))));
};
exports.default = ReportPage;
